import errorManager from "common/managers/error";
import template from "./ErrorView.html";
import ViewModel from "./ErrorViewModel";
import LocaleWidget from "common/widgets/locale/Locale";
import View from "app/core/View";
import "common/bindings/open";
import "app/widgets/DFGrid/BasicGrid";
import "app/widgets/PopUpWindow/PopUpWindow";

let error = null;
const render = function() {
    if (!error) {
        error = new View(template, {
            model: new ViewModel(),
            wrap: false
        });
        error.render($(document.body));
    }
    return error.model;
};

export default {
    errorServer: function(err) {
        render().errorServer(err);
    },

    errorMessage: function(err) {
        render().errorMessage(err);
    },

    errorMalformed: function(err) {
        render().errorMalformed(err);
    },

    errorTimeout: function() {
        render().errorTimeout();
    },

    errorClient: function(err) {
        render().errorClient(err);
    }
};
